module.exports = __webpack_public_path__ + "img/longest-streak.6298d552.svg";